<template>
  <div
    v-if="mostUrgent"
    class="mutabakat-banner"
    :class="mostUrgent.must_approve ? 'mutabakat-banner--overdue' : 'mutabakat-banner--warning'"
  >
    <div class="mutabakat-banner__inner">
      <v-icon color="white" size="18" class="mutabakat-banner__icon">
        {{ icons.mdiAlertCircleOutline }}
      </v-icon>

      <div class="mutabakat-banner__text">
        <span class="font-weight-bold">{{ mostUrgent.mutabakat_no }} numaralı mutabakatınız</span>
        onayınızı bekliyor —
        {{
          mostUrgent.must_approve
            ? "süre doldu, onaylanana kadar sipariş veremezsiniz."
            : "süresi dolmadan onaylamanızı rica ederiz."
        }}
      </div>

      <div class="mutabakat-banner__badge">
        {{ badgeText }}
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue-demi";
import { useAppStore } from "@/stores/app";
import { mdiAlertCircleOutline } from "@mdi/js";

// has-mutabakat-banner class'ı App.vue'nun kök elemanına Vue :class binding'i
// ile bağlanıyor (route geçişlerinde manuel DOM manipülasyonunun tutarsız
// kalabilmesi ihtimaline karşı) — bkz. App.vue hasPendingMutabakat computed'ı.
// O class, styles.scss'te header/nav/içerik için sabit offset tanımlıyor.
export default {
  setup() {
    const appStore = useAppStore();

    // must_approve olanlar önce, sonra en az kalan günlü olan gösterilir
    const mostUrgent = computed(() => {
      const list = appStore.pendingMutabakat || [];
      if (!list.length) return null;
      const overdue = list.find((item) => item.must_approve);
      if (overdue) return overdue;
      return [...list].sort(
        (a, b) => (a.remaining_days ?? Infinity) - (b.remaining_days ?? Infinity)
      )[0];
    });

    const badgeText = computed(() => {
      const item = mostUrgent.value;
      if (!item) return "";
      if (item.must_approve) return "Süre Doldu";
      if (item.remaining_days != null) return `${item.remaining_days} Gün Kaldı`;
      return "";
    });

    return {
      mostUrgent,
      badgeText,
      icons: {
        mdiAlertCircleOutline,
      },
    };
  },
};
</script>

<style scoped>
.mutabakat-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 40px;
  /* header'ın (z-index:5) kesin üstünde görünür. Sepet çekmecesi/navigasyon
     drawer'ı bundan yüksek z-index'e sahip (bkz. styles.scss'teki
     .app-navigation-menu/sepet override'ı) olduğundan onların altında kalır. */
  z-index: 20 !important;
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.mutabakat-banner--overdue {
  background: linear-gradient(90deg, #e6393f 0%, #ff5c61 100%);
}

.mutabakat-banner--warning {
  background: linear-gradient(90deg, #e69200 0%, #ffb400 100%);
}

.mutabakat-banner__inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}

.mutabakat-banner__icon {
  flex-shrink: 0;
}

.mutabakat-banner__text {
  color: #fff;
  font-size: 0.8125rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mutabakat-banner__badge {
  flex-shrink: 0;
  background-color: rgba(255, 255, 255, 0.22);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 999px;
  white-space: nowrap;
}
</style>
